<template>
  <div class="c-table-horizontal">
    <table>
      <caption>
        제품정보
      </caption>
      <colgroup>
        <col style="width: 120px" />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">구분</th>
          <td>
            {{ props.product.prodh1t }} &gt; {{ props.product.prodh2t }} &gt;
            {{ props.product.prodh3t }}
          </td>
        </tr>
        <tr v-if="props.product.setgdYn!='Y'">
          <th scope="row">규격</th>
          <td>
            <template v-for="(spec, index) in specs" :key="spec">
              {{ index > 0 ? " / " : "" }}
              {{
                spec.zzlqdCls === "A"
                  ? "주제"
                  : spec.zzlqdCls === "B"
                    ? "경화제"
                    : spec.zzlqdCls === "C"
                      ? "경화촉진제"
                      : spec.zzlqdCls === "D"
                        ? "희석제"
                        : ""
              }}
              :
              {{ spec.zztotalQty }}
            </template>
          </td>
        </tr>
        <tr>
          <th scope="row">색상계열</th>
          <td>{{ props.product.zzcolorTyp }}</td>
        </tr>
        <tr>
          <th scope="row">정보</th>
          <td
            v-html="
              Utils.replace(
                cmUtil.sanitizeHTML(props.product.goodsInfoCn),
                '\n',
                '<br/>'
              )
            "
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
import { computed, defineProps, onMounted } from "vue";
import * as cmUtil from "@/utils/cmUtil.js";
import Utils from "@/js/utils";

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

onMounted(() => {});

const specs = computed(() => {
  return props.product.bomItemList.length > 0
    ? props.product.bomItemList.map((item) => {
        return {
          zzlqdCls: item.zzlqdCls,
          zztotalQty: item.zztotalQty,
        };
      })
    : [
        {
          zzlqdCls: props.product.zzlqdCls,
          zztotalQty: props.product.zztotalQty,
        },
      ];
});
</script>
